import { OpenableAction } from '@execonline-inc/execonline-ui/dist/hooks/useOpenable/Types';
import { observer } from 'mobx-react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../../../Translations';
import { trackIntercomEvent } from '../../../../../../../../services/intercomTrackingService';

interface Props {
  onClose: OpenableAction;
  sectionName: string;
  addedCount?: number;
}

function ExperienceModalHeader({ onClose }: Props) {
  const handleBackToCollection = () => {
    trackIntercomEvent('Builder V2 - Course Catalog - Back to Collection');
    onClose();
  };

  return (
    <div className="flex-none px-8 pt-6 pb-4 border-b border-border">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-2xl font-semibold leading-8 text-foreground mb-2">
            <T kind="Course Catalog" />
          </h1>
          <p className="text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
            <T kind="Build your learning collection by selecting courses aligned to your talent objectives." />
          </p>
        </div>
        <button
          onClick={handleBackToCollection}
          className="flex-shrink-0 flex items-center gap-2 px-4 py-2 border border-primary text-primary bg-background rounded-md hover:bg-muted transition-colors"
          style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
          data-intercom-target="builder-v2-course-catalog-close-button"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          <T kind="Back to collection" />
        </button>
      </div>
    </div>
  );
}

export default observer(ExperienceModalHeader);
